
import crypto from 'crypto';
import querystring from 'querystring';

const nonce = (len: number) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < len; i++) { text += possible.charAt(Math.floor(Math.random() * possible.length)); }
  return text;
};

const forceUnicodeEncoding = (string: string) => decodeURIComponent(encodeURIComponent(string));

export const createdSignedEmbedUrl = (options: any) => {
  // looker options
  const { secret } = options;
  const { host } = options;

  // user options
  const jsonExternalUserId = JSON.stringify(options.externalUserId);
  const jsonFirstName = JSON.stringify(options.firstName);
  const jsonLastName = JSON.stringify(options.lastName);
  const jsonPermissions = JSON.stringify(options.permissions);
  const jsonModels = JSON.stringify(options.models);
  const jsonGroupIds = JSON.stringify(options.groupIds);
  const jsonExternalGroupId = JSON.stringify(options.externalGroupId || '');
  const jsonUserAttributes = JSON.stringify(options.userAttributes || {});
  const jsonAccessFilters = JSON.stringify(options.accessFilters);

  // url/session specific options
  const embedPath = `/login/embed/${encodeURIComponent(options.embedUrl)}`;
  const jsonSessionLength = JSON.stringify(options.sessionLength);
  const jsonForceLogoutLogin = JSON.stringify(options.forceLogoutLogin);

  // computed options
  const jsonTime = JSON.stringify(Math.floor(new Date().getTime() / 1000));
  const jsonNonce = JSON.stringify(nonce(16));

  // compute signature
  let stringToSign = '';
  stringToSign += `${host}\n`;
  stringToSign += `${embedPath}\n`;
  stringToSign += `${jsonNonce}\n`;
  stringToSign += `${jsonTime}\n`;
  stringToSign += `${jsonSessionLength}\n`;
  stringToSign += `${jsonExternalUserId}\n`;
  stringToSign += `${jsonPermissions}\n`;
  stringToSign += `${jsonModels}\n`;
  stringToSign += `${jsonGroupIds}\n`;
  stringToSign += `${jsonExternalGroupId}\n`;
  stringToSign += `${jsonUserAttributes}\n`;
  stringToSign += jsonAccessFilters;

  const signature = crypto
    .createHmac('sha1', secret)
    .update(forceUnicodeEncoding(stringToSign))
    .digest('base64')
    .trim();

  const queryParams = {
    nonce: jsonNonce,
    time: jsonTime,
    session_length: jsonSessionLength,
    external_user_id: jsonExternalUserId,
    permissions: jsonPermissions,
    models: jsonModels,
    access_filters: jsonAccessFilters,
    first_name: jsonFirstName,
    last_name: jsonLastName,
    group_ids: jsonGroupIds,
    external_group_id: jsonExternalGroupId,
    user_attributes: jsonUserAttributes,
    force_logout_login: jsonForceLogoutLogin,
    signature,
  };

  const queryString = querystring.stringify(queryParams);

  return `https://${host}${embedPath}?${queryString}`;
};
